import styled from '@emotion/styled';

import { textareaBaseStyles } from '@/components/common/form/controlStyles';

export const Container = styled.pre`
	${(props) => textareaBaseStyles(props.theme)};
	display: block;
	margin: 0;
	white-space: pre-wrap;
	word-break: break-word;
	overflow-x: auto;
	font-family: inherit;
`;
